/* Copyright (c) 2020-present CloudIO Inc */

import { Platform } from '../../platform/Platform';
import { ActionManager, ActionManagerFn } from '../../registry/Component.type';
import { baseActionManager, baseActionProps } from '../../registry/Components';
import { defaultValue } from './ActionGoToAddFunction';

const ActionGoToAddFunctionManager: ActionManagerFn<'ActionGoToAddFunction'> = (
  platform: Platform,
): ActionManager<'ActionGoToAddFunction'> => {
  return {
    ...baseActionManager(platform, 'ActionGoToAddFunction'),
    defaultValue,
    props: {
      ...baseActionProps,
    },
    name: 'Go To Add Function',
    icon: { iconName: 'external-link' },
    description: `**Overview**<br/>
The "Go To Add Function" action is a specialized, system-level navigation component designed primarily for internal platform workflows. Its specific purpose is to trigger a direct navigation event that routes the user to the interface responsible for creating or configuring new Server Functions.<br/><br/>
Like its Data Source counterpart, this component operates with a fixed internal behavior. It does not require target parameters or custom configuration from the developer, as the destination—the function creation environment—is predetermined by the platform's internal routing logic.

**Key Features**<br/>
* **Internal Utility:** Explicitly designated as a "CloudIO Internal Action," indicating it is intended for use within administrative or builder contexts rather than standard end-user applications.
* **Fixed Destination:** Functionally hardcoded to navigate to the "Add Function" screen, eliminating the need for URL or page ID configuration.
* **Zero Configuration:** Inherits all properties directly from baseActionManager without defining any component-specific inputs.

**Properties**<br/>
* **Base Properties:** This component utilizes ...baseActionProps exclusively, accepting only the standard configuration options available to all actions.

**Use Cases**<br/>
* **Builder Shortcuts:** Used within the application development environment to provide developers with quick access to the function editor.
* **Administrative Wizards:** Integrated into system setup flows that guide administrators through the process of defining server-side logic.`,
  };
};

export default ActionGoToAddFunctionManager;
